exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3ZCQAOmq01KoCp6pMYWvcy{margin-bottom:20px}._1PgImmbHXe5ZOidT8Bf9Ip{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1PgImmbHXe5ZOidT8Bf9Ip{margin-bottom:20px}html[dir] .COPSXHx2tN6_7YRXDPplL{margin-top:-8px}html[dir] ._S8weWu3hlh7H4ynrRl0E{margin-bottom:10px}html[dir] ._1pBGYjjL8r5nt-ByYehS_B{margin:0}", ""]);

// exports
exports.locals = {
	"renameFolders": "_3ZCQAOmq01KoCp6pMYWvcy",
	"reloadButton": "_1PgImmbHXe5ZOidT8Bf9Ip",
	"quickSettingWrapper": "COPSXHx2tN6_7YRXDPplL",
	"quickSettingOption": "_S8weWu3hlh7H4ynrRl0E",
	"dropdown": "_1pBGYjjL8r5nt-ByYehS_B"
};